module.exports = __webpack_public_path__ + "static/entry-number-box-sample-95f0080517df318bb2eac6617c9cba9c.png";